/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <div class="tabla-scrollable">
        <table class="default">
            <thead>
                <tr class="cabecera">
                    <th>No. ID</th>
                    <th>Nombre</th>
                    <th>Ciudad</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody class="tbody">
                <tr v-if="mostrarLoaderInterno" class="fila-loader">
                    <td colspan="9" class="loader-wrapper">
                        <LoadScreenModal class="loader-solo" /> 
                    </td>
                </tr>
                <tr v-else-if="listaProveedores.length === 0">
                    <td colspan="9" class="mensajeNoResultados">
                        No hay proveedor seleccionado o la lista está vacía.
                    </td>
                </tr>
                <tr v-else v-for="proveedor in listaProveedores" :key="proveedor.id_proveedor"> 
                  <td>{{ proveedor.id_proveedor.toString().padStart(3, '0') }}</td>
                  <td>{{ proveedor.Nombre }}</td>
                  <td>{{ proveedor.Ciudad }}</td>
                  <td>{{ proveedor.Estado }}</td>
                  <td>
                      <div class="botonesTabla">
                          <Button class="btn-editar" @click="$emit('detalles', proveedor.id_proveedor, Tipo)"
                              title="Ver precios/productos">
                              <i class="fa-solid fa-sliders"></i>
                          </Button>

                          <template v-if="esPropietario(proveedor)">
                              <Button class="btn-editar" @click="$emit('editar', proveedor.id_proveedor, Tipo)"
                                  title="Editar proveedor">
                                  <i class="fa-solid fa-pen-to-square"></i>
                              </Button>
                              <Button class="btn-eliminar" @click="$emit('eliminar', proveedor, Tipo)"
                                  title="Eliminar proveedor">
                                  <i class="fa-solid fa-trash"></i>
                              </Button>
                          </template>

                          <div v-else title="Proveedor global (solo lectura)"></div>
                      </div>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Button from "../Forms/Button.vue";
import LoadScreenModal from "../Forms/LoadScreenModal.vue";


export default {
    name: 'TablaProveedores',
    components: { Button,LoadScreenModal },
    props: {
        listaProveedores: { type: Array, required: true },
        mostrarLoaderInterno: { type: Boolean, default: false },
        Tipo: { type: String, required: true } 
    },
    emits: ['detalles', 'editar', 'eliminar'],
    data() {
        return {
            idUsuarioLogueado: null
        };
    },
    mounted() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        this.idUsuarioLogueado = userData ? userData.id_usuario : null;
    },

    methods: {
        esPropietario(proveedor) {
            return proveedor.usuario === this.idUsuarioLogueado;
        }
    }
};
</script>

<style scoped>
.titulo {
  padding: 30px 0px 0px 0px;
  font-size: 30px;
}

.tituloNombre {
  font-style: italic;
  font-size: 27px;
  color: #29b9f6;
  font-weight: 600;
}

.botonesTitulo {
  padding-top: 30px;
  display: flex;
  gap: 10px;
}

.separador {
  border-top: 3px solid #2a428c;
  height: 2px;
  max-width: 100%;
  padding: 0;
  margin-top: 5px;
  margin: 5px 0px 20px;
}

.SeccionInfoGeneral {
  padding-bottom: 20px;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
}

.contenido-modal {
  width: 1000px !important;
}

.separacion {
  padding: 2.5px 0px;
  font-size: 17px;
  font-weight: bold;
  min-width: 250px;
}

.fuenteSep {
  font-size: 15px;
  font-weight: normal;
}

.contenedorPrincipal {
  margin: 0px 30px;
}

.contenedorTituloNombre {
  display: flex;
  justify-content: space-between;
}

.inputEditar {
  width: 200px;
  height: 32px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #000000;
  padding: 0px 7px;
  border-radius: 10px;
  margin: 0px 10px;
}

.contenedorBotones {
  display: flex;
  justify-content: center;
  max-width: 80%;
  margin: auto;
  padding: 30px 0px 20px;
}

.totales {
  background-color: #f1f1f1;
  font-weight: bold;
}

.cabecera {
  background: black;
  color: white;
}

.tablaPrincipal {
  width: 100%;
  overflow-x: auto;
}

.default {
  border-collapse: collapse;
  border-radius: 10px;
  width: 100%;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}

.default td,
.default th {
  border: none;
  padding: 15px 12px;
  text-align: center;
}

.tbody {
  font-size: 14.5px;
  background-color: #f8fafc;
}

.default tr:nth-child(even) {
  background-color: #f8fafc;
}

.inputEditarTabla {
  width: 120px;
  height: 32px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #000000;
  padding: 0px 7px;
  border-radius: 10px;
  margin: 0px;
  text-align: center;
}

@media (max-width: 810px) {
  .titulo {
    font-size: 25px
  }

  .tituloNombre {
    font-size: 24px
  }

  .SeccionInfoGeneral {
    flex-direction: column;
    gap: 10px;
  }

  .separacion {
    font-size: 15px;
    min-width: 100%;
  }

  .fuenteSep {
    font-size: 13px
  }

  .default td {
    font-size: 12px;
    letter-spacing: 0px;
    padding: 10px 5px;
  }

  .default th {
    padding: 10px 5px;
    font-size: 13px;
    letter-spacing: 0px;
  }

  .tbody {
    font-size: 10px;
    background-color: #f8fafc;
  }

  .inputEditarTabla {
    width: 70px;
    height: 30px;
    border: 0.5px solid #000000;
    box-shadow: 0px 3px 6px #00000029;
    text-align: center;
  }

  .inputEditar {
    width: 150px;
    height: 30px;
    border: 0.5px solid #000000;
    margin: 0px 3px;
  }

  .botonesTitulo {
    display: flex;
    gap: 5px;
  }

  .btn-editar,
  .btn-descargar-excel,
  .btn-atras,
  .btn-agregar {
    font-size: 13px;
    width: 30px;
    height: 30px;
  }
}
</style>